import React from 'react'
import { Link } from 'react-router-dom'
import Spotlight from './spotlight'


export default class Banner extends React.Component {
	render() {
		const {banner} = hp.store;
		return (
			<div>
				<div className={classNames("banner", this.props.className || null)}>
					{banner.image ? <img src={banner.image} alt=""/> : null}
					<div className="center title">
						{banner.title || "Portal de Sócios"}
						{!banner.subtitle || banner.subtitle.startsWith('#') ? null : <div className="subtitle">{banner.subtitle}</div>}
					</div>
				</div>
				<div className="highlights row no-gutters justify-content-md-center">
					<div className="heroslider">
						<Spotlight
							items={hp.store.highlights}
							autoPlay={true}
							arrows={true}
							renderItem={(item, i) => (
								React.createElement(item.href ? "a" : Link, {
									key: item.id,
									className: "item",
									to: "/home/news/" + item.id + '/' + item.type,
									href: item.href || "#",
									target: item.href ? "_blank" : "_self"
								}, [
									<div className="card" key="c">
										<img src={item.image} alt="" className="card-img-top" />
									</div>,
									<div className="card-body bold" key="b">
										{item.name}
									</div>
								])
							)}
							responsive={[
								{breakpoint: 1260, settings: {slidesToShow: 2}},
								{breakpoint: 760, settings: {slidesToShow: 1}},
							]}
						/>
					</div>
				</div>
			</div>
		);
	}
}

export class SimpleBanner extends React.Component {
	render() {
		const {banner} = hp.store;
		const style = banner.image
			? {backgroundImage: `url(${banner.image})`}
			: null;
		return (
			<div>
				<div className="banner simple" style={style}>
					<div className="center title">
						{this.props.title || "Portal de Sócios"}
					</div>
				</div>
			</div>
		);
	}
}
